import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function Footer() {
  const [t, i18n] = useTranslation("global");
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/setting`, {
          headers: {
            "Accept-Language": i18n.language,
          },
        });
        const result = await response.json();
        setSettings(result?.data?.[0]); // بناخد أول عنصر من المصفوفة
      } catch (error) {
        console.error("Failed to fetch settings:", error);
      }
    };

    fetchSettings();
  }, [i18n.language]);

  return (
    <footer className="bg-footer">
      <div className="container">
        <div className="d-flex flex-column flex-md-row align-items-center justify-content-between text-center footer-2">
          <div className="col-md-8 mb-4">
            <img src="/assets/imgs/logo.png" alt="Company Logo" />
            <div className="text-footer">
              <p className="footer-color">
                {settings?.description || t("footer.description")}
              </p>
            </div>
            <div className="social-icons flex-wrap justify-content-center justify-content-md-start mt-4">
              {settings?.facebook && (
                <a
                  href={settings.facebook}
                  className="icon facebook new-icon"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fa-brands fa-facebook-f text-white"></i>
                </a>
              )}
              {settings?.twitter && (
                <a
                  href={settings.twitter}
                  className="icon twitter new-icon"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i class="fab fa-x-twitter text-white"></i>
                </a>
              )}
              {settings?.youtube && (
                <a
                  href={settings.youtube}
                  className="icon youtube new-icon"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fab fa-youtube text-white"></i>
                </a>
              )}
              {settings?.tiktok && (
                <a
                  href={settings.tiktok}
                  className="icon tiktok new-icon"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fab fa-tiktok text-white"></i>
                </a>
              )}
              {settings?.instagram && (
                <a
                  href={settings.instagram}
                  className="icon instagram new-icon"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fab fa-instagram text-white"></i>
                </a>
              )}
              {settings?.telegram && (
                <a
                  href={settings.telegram}
                  className="icon telegram new-icon"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fab fa-telegram text-white"></i>
                </a>
              )}
              {settings?.snapchat && (
                <a
                  href={settings.snapchat}
                  className="icon snapchat new-icon"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fab fa-snapchat-ghost text-white"></i>
                </a>
              )}
              {settings?.whatsapp && (
                <a
                  href={settings.whatsapp}
                  className="icon whatsapp new-icon"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fab fa-whatsapp text-white"></i>
                </a>
              )}
            </div>
            <div className="mt-3">
      <p className="footer-color mb-1">
        {t("footer.phone")} : <span>{settings?.phone || "01062124924"}</span>
      </p>
      <p className="footer-color mb-1">
        {t("footer.email")} : <Link to={`mailto:${settings?.email || 'Tamayez@gmail.com'}`}>{settings?.email || "Tamayez@gmail.com"}</Link>
      </p>
      <p className="footer-color mb-1">
  {t("footer.address")} : <span>{settings?.address || t("footer.addressValue")}</span>
</p>

    </div>
          </div>

          <div className="col-md-3 mb-4">
            <h4 className="footer-color">{t("footer.company")}</h4>
            <ul className="footer-color list-unstyled">
              <Link to="/about-us">
                <li className="mt-4 mb-2">{t("footer.about")}</li>
              </Link>
              <Link to="/courses">
                <li className="my-2">{t("footer.courses")}</li>
              </Link>
              <Link to="/Instructors">
                <li className="my-2">{t("footer.instructor")}</li>
              </Link>
              <Link to="/support">
                <li className="my-2">{t("footer.support")}</li>
              </Link>
              <Link to="/terms">
                <li className="my-2">{t("footer.terms")}</li>
              </Link>
              <Link to="/returpolicy">
                <li className="my-2">{t("footer.returpolicy")}</li>
              </Link>
              <Link to="/privacypolicy">
                <li className="my-2">{t("footer.privacypolicy")}</li>
              </Link>
            </ul>
          </div>
        </div>
      </div>

      <div className="mt-5">
        <hr style={{ color: "#fff" }} className="m-0 pt-5 hr-footer" />
      </div>
      <p style={{ textAlign: "center", color: "white" }}>
        {t("footer.copyright")} {t("footer.developedBy")}{" "}
        <Link
          to="https://brmja.tech/"
          className="footer-copyright"
          style={{
            color: "orange",
            textDecoration: "none",
          }}
          target="_blank"
          rel="noopener noreferrer"
        >
          {t("footer.brmjaTech")}
        </Link>
      </p>
    </footer>
  );
}
